import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { FaSignOutAlt } from "react-icons/fa";

const LogoutButton = ({ style = {}, className = "" }) => {
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {user?.username && (
        <span style={{ fontSize: "14px", opacity: 0.9, fontWeight: 500 }}>
          {user.name || user.username} ({user.role})
        </span>
      )}
      <button
        onClick={handleLogout}
        className={className}
        style={{
          backgroundColor: "#dc3545",
          color: "#ffffff",
          border: "none",
          borderRadius: "6px",
          padding: "7px 14px",
          fontSize: "14px",
          fontWeight: "600",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          transition: "background-color 0.2s ease",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          ...style,
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#bb2d3b")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#dc3545")}
      >
        <FaSignOutAlt /> Logout
      </button>
    </div>
  );
};

export default LogoutButton;
